<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item :label="$t('views.appConfig.form.group')" prop="configGroup" >
        <a-input v-model="form.configGroup" :disabled="formType == 2" :placeholder="$t('views.appConfig.form.groupPlaceholder')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('views.appConfig.form.varName')" prop="configName" >
        <a-input v-model="form.configName" :disabled="formType == 2" :placeholder="$t('views.appConfig.form.varNamePlaceholder')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('views.appConfig.form.varTitle')" prop="title" >
        <a-input v-model="form.title" :placeholder="$t('views.appConfig.form.varTitlePlaceholder')" />
      </a-form-model-item>

      <a-form-model-item :label="$t('views.appConfig.form.paramType')" prop="type">
        <a-radio-group v-model="form.type" button-style="solid">
          <a-radio-button v-for="(d, index) in configTypeOptions" :key="index" :value="d.value">
            {{ d.label }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item :label="$t('views.appConfig.form.value')" prop="configValue" >
        <a-textarea v-model="form.configValue" :placeholder="$t('views.appConfig.form.valuePlaceholder')" v-if="form.type== 1 " />
        <editor :key="'configValue-' + (form.id || 'new')" v-if="form.type == 2" v-model="form.configValue" />
        <a-input-number style="width: 100%;" v-if="form.type == 3" v-model="form.configValue" :placeholder="$t('views.appConfig.form.valueNumberPlaceholder')" :min="0"/>
        <a-upload
          v-if="form.type == 4"
          listType="picture-card"
          class="avatar-uploader"
          :show-upload-list="false"
          :beforeUpload="(info) => fileBeforeUpload('configValue',info)"
          :customRequest="(info) => fileUploadRequest('configValue',info)"
          v-model="form.configValue">
          <img v-if="form.type ==4 && form.configValue != null" :src="form.configValue" style="height:104px;max-width:300px" />
          <div v-else>
            <a-icon :type="loading ? 'loading' : 'plus'" />
            <div class="ant-upload-text">{{ loading ? $t('views.appConfig.upload.uploading') : $t('views.appConfig.upload.action') }}</div>
          </div>
        </a-upload>
      </a-form-model-item>

      <a-form-model-item :label="$t('views.appConfig.form.valueEn')" prop="configValueEn" >
        <a-textarea v-model="form.configValueEn" :placeholder="$t('views.appConfig.form.valueEnPlaceholder')" v-if="form.type== 1 " />
        <editor :key="'configValueEn-' + (form.id || 'new')" v-if="form.type == 2" v-model="form.configValueEn" />
        <a-input-number style="width: 100%;" v-if="form.type == 3" v-model="form.configValueEn" :placeholder="$t('views.appConfig.form.valueNumberPlaceholder')" :min="0"/>
        <a-upload
          v-if="form.type == 4"
          listType="picture-card"
          class="avatar-uploader"
          :show-upload-list="false"
          :beforeUpload="(info) => fileBeforeUpload('configValueEn',info)"
          :customRequest="(info) => fileUploadRequest('configValueEn',info)"
          v-model="form.configValueEn">
          <img v-if="form.type ==4 && form.configValueEn != null" :src="form.configValueEn" style="height:104px;max-width:300px" />
          <div v-else>
            <a-icon :type="loadingEn ? 'loading' : 'plus'" />
            <div class="ant-upload-text">{{ loadingEn ? $t('views.appConfig.upload.uploading') : $t('views.appConfig.upload.action') }}</div>
          </div>
        </a-upload>
      </a-form-model-item>

      <a-form-model-item :label="$t('views.appConfig.form.description')" prop="description" >
        <a-input v-model="form.description" :placeholder="$t('views.appConfig.form.descriptionPlaceholder')" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('views.appConfig.form.save') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('views.appConfig.form.cancel') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getConfig, addConfig, updateConfig } from '@/api/app/config'
import Editor from '@/components/Editor'
import UploadFileToOSS from '@/utils/upload-file-to-oss'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      loading: false,
      loadingEn: false,
      form: {
        id: null,
        configGroup: null,
        configName: null,
        title: null,
        description: null,
        configValue: null,
        configValueEn: null,
        type: null,
        createTime: null,
        remark: null
      },
      formType: 1,
      open: false
    }
  },
  computed: {
    formTitle () {
      return this.formType === 1
        ? this.$t('views.appConfig.title.add')
        : this.$t('views.appConfig.title.edit')
    },
    configTypeOptions () {
      return [
        { value: 1, label: this.$t('views.appConfig.type.text') },
        { value: 2, label: this.$t('views.appConfig.type.richText') },
        { value: 3, label: this.$t('views.appConfig.type.number') },
        { value: 4, label: this.$t('views.appConfig.type.image') }
      ]
    },
    rules () {
      return {
        configGroup: [
          { required: true, message: this.$t('views.appConfig.rule.groupRequired'), trigger: 'blur' }
        ],
        configName: [
          { required: true, message: this.$t('views.appConfig.rule.nameRequired'), trigger: 'blur' }
        ],
        title: [
          { required: true, message: this.$t('views.appConfig.rule.titleRequired'), trigger: 'blur' }
        ],
        configValue: [
          { required: true, message: this.$t('views.appConfig.rule.valueRequired'), trigger: 'blur' }
        ],
        type: [
          { required: true, message: this.$t('views.appConfig.rule.typeRequired'), trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    onClose () {
      this.open = false
    },
    cancel () {
      this.open = false
      this.reset()
    },
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        configGroup: null,
        configName: null,
        title: null,
        description: null,
        configValue: null,
        configValueEn: null,
        type: 1,
        createTime: null,
        remark: null
      }
    },
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
    },
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getConfig({ id }).then(response => {
        const d = response.data || {}
        const merged = { ...this.form, ...d }
        if (d.type != null) {
          merged.type = Number(d.type)
        }
        if (merged.type === 3) {
          if (merged.configValue != null && merged.configValue !== '') {
            const n = Number(merged.configValue)
            if (!Number.isNaN(n)) merged.configValue = n
          }
          if (merged.configValueEn != null && merged.configValueEn !== '') {
            const n = Number(merged.configValueEn)
            if (!Number.isNaN(n)) merged.configValueEn = n
          }
        }
        if (merged.configValue == null) merged.configValue = ''
        if (merged.configValueEn == null) merged.configValueEn = ''
        this.form = merged
        this.open = true
        this.$nextTick(() => {
          if (this.$refs.form) {
            this.$refs.form.clearValidate()
          }
        })
      })
    },
    fileBeforeUpload (field, fileInfo) {
      if (!fileInfo.type.includes('image')) {
        this.$message.warning(this.$t('views.appConfig.msg.imageOnly'))
        return false
      }
      return true
    },
    fileUploadRequest (field, fileInfo) {
      const isEn = field === 'configValueEn'
      if (isEn) {
        this.loadingEn = true
      } else {
        this.loading = true
      }
      void new UploadFileToOSS([fileInfo.file], {
        finally: (res) => {
          if (isEn) {
            this.loadingEn = false
          } else {
            this.loading = false
          }
          this.form[field] = res[0].url
        }
      })
    },
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateConfig(this.form).then(response => {
              this.$message.success(this.$t('views.appConfig.msg.updateOk'), 3)
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addConfig(this.form).then(response => {
              this.$message.success(this.$t('views.appConfig.msg.addOk'), 3)
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
